module.exports = __webpack_public_path__ + "static/media/setting.3f637009.svg";